const ContentfulTypes = {
    CATEGORY: 'Category',
    SUB_CATEGORY: 'Subcategory',
    NSC: 'Nested Subcategory',
    SEARCH_QUERY: 'Search Results',
    FILTERED_LISTING: 'Filtered Listing',
    LOGO_MAKER_IDEAS: 'Ideas',
    LINK_URL: 'linkUrl'
};

const CmsContentTypes = {
    VERTICAL_EXPERIENCE_PAGE: 'verticalExperiencePage',
    LANDING_PAGE: 'landingPage',
    CONTENT_PAGE: 'contentPage'
};

const CmsWebDesignTypes = {
    PANEL: 'Panel',
    LIST: 'List',
    BUCKETS: 'Buckets',
    BUCKETS_WITH_TITLE: 'Buckets with Title',
    BUCKETS_WITHOUT_TITLE: 'Buckets without Title'
};

const UiTypes = {
    CATEGORY: 'category',
    SUB_CATEGORY: 'sub_category',
    NSC: 'nested_sub_category',
    SEARCH_QUERY: 'search_query',
    STATIC: 'static',
    STORE: 'store',
    FILTERED_SC: 'filtered_sub_category',
    LOGO_MAKER_IDEAS: 'ideas',
    CONTENT_PAGE: 'content_page',
    LANDING_PAGE: 'landing_page',
    LINK_URL: 'link_url'
};

const UiMenuTypes = {
    MULTI_PANEL: 'multi_panel',
    DEFAULT: 'default',
    BUCKET: 'bucket',
    BUCKETS_WITH_TITLE: 'buckets_with_title',
    BUCKETS_WITHOUT_TITLE: 'buckets_without_title'
};

function recursiveFormat(json, item, parentId, level) {
    if (item.children && item.children.length > 0) {
        item.children.forEach((child) => recursiveFormat(json, child, item.id, level + 1));
    }
    addItem(json, item, parentId, level);
}

function addItem(json, raw, parentId, level) {
    const item = formatItem(raw);
    if (!item) {
        return;
    }

    addToJson(json, level, parentId, item);
}

function formatItem(raw) {
    const linkParams = linkParamsFu(raw);
    if (!linkParams) {
        return;
    }

    const optionalParams = Object.assign({}, displayData(raw), menuType(raw), badge(raw), designStyle(raw));

    return Object.assign({ id: raw.id, alias: raw.alias }, linkParams, optionalParams);
}

function addToJson(json, level, parentId, item) {
    json[`level_${level}`] = json[`level_${level}`] || {};
    json[`level_${level}`][parentId] = json[`level_${level}`][parentId] || [];
    json[`level_${level}`][parentId].push(item);
}

function badge(item) {
    return item.badge ? { badge: item.badge.toLowerCase() } : {};
}

function designStyle(item) {
    return item.webDesignStyle ? { designStyle: item.webDesignStyle } : {};
}

function menuType(item) {
    const webDesignStyle = item.webDesignStyle;
    if (!webDesignStyle) {
        return {};
    }

    let menuType;
    switch (webDesignStyle) {
        case CmsWebDesignTypes.PANEL:
            menuType = UiMenuTypes.MULTI_PANEL;
            break;
        case CmsWebDesignTypes.LIST:
            menuType = UiMenuTypes.DEFAULT;
            break;
        case CmsWebDesignTypes.BUCKETS:
            menuType = UiMenuTypes.BUCKET;
            break;
        case CmsWebDesignTypes.BUCKETS_WITH_TITLE:
            menuType = UiMenuTypes.BUCKETS_WITH_TITLE;
            break;
        case CmsWebDesignTypes.BUCKETS_WITHOUT_TITLE:
            menuType = UiMenuTypes.BUCKETS_WITHOUT_TITLE;
            break;
        default:
            break;
    }

    return menuType ? { menuType } : {};
}

function displayData(item) {
    const title = item.alias;
    let subTitle = item.subtitle;
    if (!title) {
        return {};
    }
    if (!subTitle) {
        subTitle = null;
    }

    return { displayData: { title, subTitle } };
}

function webLinkTypeDecider(webLink) {
    switch (webLink?.type) {
        case ContentfulTypes.CATEGORY:
            return categoryTransformer(webLink);
        case ContentfulTypes.SUB_CATEGORY:
            return subCategoryTransformer(webLink);
        case ContentfulTypes.NSC:
            return nscTransformer(webLink);
        case ContentfulTypes.SEARCH_QUERY:
            return searchQueryTransformer(webLink);
        case ContentfulTypes.FILTERED_LISTING:
            return filteredListingPageTransformer(webLink);
        case ContentfulTypes.LOGO_MAKER_IDEAS:
            return logoMakerTransformer(webLink);
        default:
            return staticTransformer();
    }
}

function linkParamsFu(item) {
    const webLink = item.webLink;
    const cmsContentType = webLink?.cmsContentType;

    if (webLink?.contentType === ContentfulTypes.LINK_URL) {
        return urlLinkTransformer(webLink);
    } else if (cmsContentType) {
        switch (cmsContentType) {
            case CmsContentTypes.VERTICAL_EXPERIENCE_PAGE:
                return cmsLinkTransformer(webLink, UiTypes.STORE);
            case CmsContentTypes.LANDING_PAGE:
                return cmsLinkTransformer(webLink, UiTypes.LANDING_PAGE);
            case CmsContentTypes.CONTENT_PAGE:
                return cmsLinkTransformer(webLink, UiTypes.CONTENT_PAGE);
            default:
                return null;
        }
    } else {
        return webLinkTypeDecider(webLink);
    }
}

function filters(data) {
    return data.encoded_filters ? { queryParams: data.encoded_filters } : {};
}

function categoryTransformer(data) {
    const id = data.category_id;
    return id ? { type: UiTypes.CATEGORY, urlParams: { id, ...filters(data) } } : null;
}

function subCategoryTransformer(data) {
    const categoryId = data.category_id;
    const id = data.sub_category_id;
    return id && categoryId ? { type: UiTypes.SUB_CATEGORY, urlParams: { categoryId, id, ...filters(data) } } : null;
}

function nscTransformer(data) {
    const id = data.nested_subcategory_id;
    const categoryId = data.category_id;
    const subCategoryId = data.sub_category_id;
    return id && categoryId && subCategoryId ? { type: UiTypes.NSC, urlParams: { categoryId, subCategoryId, id, ...filters(data) } } : null;
}

function searchQueryTransformer(data) {
    const searchTerm = data.search_term;
    const categoryId = data.category_id;
    const subCategoryId = data.sub_category_id;
    const additionalParams = searchTerm && categoryId && subCategoryId ? { categoryId, id: subCategoryId } : {};
    return searchTerm ? { type: UiTypes.SEARCH_QUERY, urlParams: { query: searchTerm, ...additionalParams, ...filters(data) } } : null;
}

function cmsLinkTransformer(data, type) {
    const slug = data.slug;
    const entryId = data.cmsEntryId;
    return slug && entryId ? { type, urlParams: { slug, entryId } } : null;
}

function urlLinkTransformer(data) {
    const url = data?.url;
    return url ? { type: UiTypes.LINK_URL, urlParams: { url, ...filters(data) } } : null;
}

function filteredListingPageTransformer(data) {
    const categoryId = data.category_id;
    const subCategoryId = data.sub_category_id;
    const nestedSubcategoryId = data.nested_subcategory_id;
    const filterUid = data.leadingFilter;
    const encodedFilters = data.encoded_filters;
    const additionalParams = nestedSubcategoryId ? { nestedSubCategoryId: nestedSubcategoryId } : {};
    return categoryId && subCategoryId && filterUid && encodedFilters ? {
        type: UiTypes.FILTERED_SC,
        urlParams: { categoryId, id: subCategoryId, filterUid, mobileFilter: encodedFilters, ...additionalParams, ...filters(data) }
    } : null;
}

function logoMakerTransformer(data) {
    const tag = data.tag;
    const tagType = data.tagType;
    return tag ? { type: UiTypes.LOGO_MAKER_IDEAS, urlParams: { tag, tagType, ...filters(data) } } : null;
}

function staticTransformer() {
    return { type: UiTypes.STATIC };
}

export const cmsConfigTransformer = (cmsConfig) => {
    const config = {};
    cmsConfig.children.forEach(
        (child) => recursiveFormat(config, child, '0', 1)
    );

    return config;
};
